import Loader from "../../components/Loader";
import {useQuery} from "@tanstack/react-query";
import Coupon from "./Coupon";
import {useContext, useEffect, useState} from "react";
import Paginator from "../../components/Paginator";
import {
    Col ,
    Form ,
    FormFeedback ,
    Row ,
    Input ,
    Label ,
    Button ,
    Accordion ,
    UncontrolledAccordion ,
    AccordionItem ,
    AccordionBody , AccordionHeader
} from "reactstrap";
import AuthContext from "../../context/AuthContext";
import handleUnauthorized401QueryError from "../../utils/handleUnauthorized401QueryError";
import {getCoupons} from "../../api/api";
import {toast} from "react-toastify";
import AddCouponButton from "./AddCouponButton";
import RecordsNotFound from "../../components/RecordsNotFound";


function CouponPage() {
    const {refreshToken, user} = useContext(AuthContext)
    const [page, setPage] = useState(1);
    const [couponId, setCouponId] = useState("");
    const [couponCode, setCouponCode] = useState("");
    // const [customers, setCustomers] = useState("");
    const [couponName, setCouponName] = useState("");
    const [couponValue, setCouponValue] = useState("");
    const [couponType, setCouponType] = useState("");
    const [couponPercentage, setCouponPercentage] = useState("");
    const [couponStock, setCouponStock] = useState("");
    const [couponStatus, setCouponStatus] = useState("");
    const [couponMinimumCartValue, setCouponMinimumCartValue] = useState("");
    const [couponMaxValue, setCouponMaxValue] = useState("");
    // const [couponExpirationDate, setCouponExpirationDate] = useState("");
    const [couponForFirstOrder, setCouponForFirstOrder] = useState("");
    const [couponApplicableTo, setCouponApplicableTo] = useState("");
    const [couponCreatedDate, setCouponCreatedDate] = useState("");
    const [couponUpdatedDate, setCouponUpdatedDate] = useState("");

    const [queryKey, setQueryKey] = useState(['coupons', page])

    const [openAdvancedSearch, setOpenAdvancedSearch] = useState(false);
    const [isAdvancedSearchDisabled, setIsAdvancedSearchDisabled] = useState(false);

    const toggleAdvancedSearch = () =>
        setOpenAdvancedSearch((prevState) => !prevState);

    useEffect(() => {
        setQueryKey(['coupons', page])
    }, [page]);

    useEffect(() => {
        if(couponId === '' && couponCode === '' && couponName === '' && couponValue === '' &&
           couponType === '' && couponPercentage === '' && couponStock === '' && couponStatus === '' &&
           couponMinimumCartValue === '' && couponMaxValue === ''
            && couponForFirstOrder === '' && couponApplicableTo === '' && couponCreatedDate === '' &&
            couponUpdatedDate === ''){
            clearSearchCoupon()
        }
    }, [couponId, couponCode, couponName, couponValue, couponType, couponPercentage,
        couponStock, couponStatus, couponMinimumCartValue, couponMaxValue, couponForFirstOrder,
        couponApplicableTo, couponCreatedDate, couponUpdatedDate]);


    const { status, data, error, isFetching, refetch } = useQuery({
                  queryKey: queryKey,
                  queryFn: () => getCoupons(page, couponId, couponCode, couponName, couponValue,
                      couponType, couponPercentage, couponStock, couponStatus, couponMinimumCartValue, couponMaxValue,
                      couponForFirstOrder, couponApplicableTo, couponCreatedDate, couponUpdatedDate),
                  keepPreviousData : true,
                  retry: false,
                  onError: (err => {
                      handleUnauthorized401QueryError(err, refreshToken, refetch)
                      if(err.response.status !== 401){
                          toast.error(`An error occurred! ${err?.response?.data?.detail}`)
                      }
                  })
              })

    const searchCoupon = (e) =>{
        e?.preventDefault()
        setPage(1)
        setQueryKey( ['coupons', page, couponId, couponCode, couponName, couponValue, couponType, couponPercentage,
                         couponStock, couponStatus, couponMinimumCartValue, couponMaxValue,
                         couponForFirstOrder, couponApplicableTo, couponCreatedDate, couponUpdatedDate])
    }

    const clearSearchCoupon = (e) =>{
        e?.preventDefault()
        setCouponId('')
        setCouponCode('')
        // setCustomers('')
        setCouponName('')
        setCouponValue('')
        setCouponType('')
        setCouponPercentage('')
        setCouponStock('')
        setCouponStatus('')
        setCouponMinimumCartValue('')
        setCouponMaxValue('')
        setCouponForFirstOrder('')
        setCouponApplicableTo('')
        setCouponCreatedDate('')
        setCouponUpdatedDate('')
        setQueryKey( ['coupons', 1])
        // setPage(1)
    }

    return (
        <>
            <UncontrolledAccordion defaultOpen="" flush={true}>
            <AccordionItem>
                <AccordionHeader targetId="1">
                    <span><i className="mdi mdi-filter"/></span>
                </AccordionHeader>
                <AccordionBody accordionId="1">
                        <div className="card-box">
                            <div className="row">
                                <div className="col-sm-12">

                                    <Form onSubmit={searchCoupon}>
                                        <Row className="form-row align-items-center">
                                            <Col>
                                                <Label
                                                    className="visually-hidden"
                                                    for="coupon-code"
                                                >
                                                    Coupon Code
                                                </Label>
                                                <Input
                                                    id="coupon-code"
                                                    name="coupon-code"
                                                    type="text"
                                                    className="form-control mb-2"
                                                    onChange={(e) =>
                                                        setCouponCode(
                                                            e.target.value
                                                        )
                                                    }
                                                    value={couponCode}
                                                    invalid={
                                                        error && error.response.data.code
                                                    }
                                                />
                                                <FormFeedback invalid>
                                                    {error && error.response.data.code}
                                                </FormFeedback>
                                            </Col>
                                            <Col>
                                                <Label
                                                    className="visually-hidden"
                                                    for="coupon-value"
                                                >
                                                    Value
                                                </Label>
                                                <Input
                                                    id="coupon-value"
                                                    name="coupon-value"
                                                    type="number"
                                                    className="form-control mb-2"
                                                    defaultValue={couponValue}
                                                    onChange={(e) =>
                                                        setCouponValue(
                                                            e.target.value
                                                        )
                                                    }
                                                    value={couponValue}
                                                    invalid={
                                                        error && error.response.data.value
                                                    }
                                                />
                                                <FormFeedback invalid>
                                                    {error && error.response.data.value}
                                                </FormFeedback>
                                            </Col>
                                            <Col>
                                                <Label
                                                    className="visually-hidden"
                                                    for="coupon-type"
                                                >
                                                    Type
                                                </Label>
                                                <Input
                                                    type="select"
                                                    id="coupon-type"
                                                    className="form-control mb-2"
                                                    value={couponType}
                                                    onChange={(e) =>
                                                        setCouponType(
                                                            e.target.value
                                                        )
                                                    }
                                                >
                                                    <option value="">--</option>
                                                    <option value={"FLAT"}>
                                                        Flat
                                                    </option>
                                                    <option value={"PERCENTAGE"}>
                                                        Percentage
                                                    </option>
                                                </Input>
                                            </Col>
                                            <Col>
                                                <Label
                                                    className="visually-hidden"
                                                    for="coupon-status"
                                                >
                                                    Status
                                                </Label>
                                                <Input
                                                    type="select"
                                                    id="coupon-status"
                                                    className="form-control mb-2"
                                                    value={couponStatus}
                                                    onChange={(e) =>
                                                        setCouponStatus(
                                                            e.target.value
                                                        )
                                                    }
                                                >
                                                    <option value="">--</option>
                                                    <option value={"ACTIVE"}>
                                                        Active
                                                    </option>
                                                    <option value={"REVOKED"}>
                                                        Revoked
                                                    </option>
                                                </Input>
                                            </Col>
                                            <Col>
                                                <Label
                                                    className="visually-hidden"
                                                    for="coupon-date-created"
                                                >
                                                    Date Created
                                                </Label>
                                                <Input
                                                    id="coupon-date-created"
                                                    name="coupon-date-created"
                                                    type="date"
                                                    className="form-control mb-2"
                                                    onChange={(e) =>
                                                        setCouponCreatedDate(
                                                            e.target.value
                                                        )
                                                    }
                                                    value={couponCreatedDate}
                                                    invalid={
                                                        error && error.response.data.created
                                                    }
                                                />
                                                <FormFeedback invalid>
                                                    {error && error.response.data.created}
                                                </FormFeedback>
                                            </Col>

                                        </Row>
                                        {!isAdvancedSearchDisabled && (
                                            <>
                                                <Row className="form-row align-items-center">
                                                    <Col>
                                                        <div className="form-check">
                                                            <Input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                id="advanced-search"
                                                                defaultChecked={openAdvancedSearch}
                                                                disabled={isAdvancedSearchDisabled}
                                                                onChange={() =>
                                                                    toggleAdvancedSearch()
                                                                }
                                                            />
                                                            <Label
                                                                check
                                                                className="form-check-label mb-2"
                                                                for="advanced-search"
                                                            >
                                                                Advanced Search
                                                            </Label>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Accordion open={openAdvancedSearch}>
                                                    <AccordionItem>
                                                        <AccordionBody accordionId={true}>
                                                            <Row className="form-row align-items-center">
                                                                <Col>
                                                                    <Label
                                                                        className="visually-hidden"
                                                                        for="name"
                                                                    >
                                                                        Coupon Name
                                                                    </Label>
                                                                    <Input
                                                                        id="coupon-name"
                                                                        name="coupon-name"
                                                                        type="text"
                                                                        className="form-control mb-2"
                                                                        onChange={(e) =>
                                                                            setCouponName(
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                        value={couponName}
                                                                        invalid={
                                         error && error.response.data.name
                                                                        }
                                                                    />
                                                                    <FormFeedback invalid>
                                                                        {error && error.response.data.name}
                                                                    </FormFeedback>
                                                                </Col>
                                                                <Col>
                                                                    <Label
                                                                        className="visually-hidden"
                                                                        for="stock"
                                                                    >
                                                                        Stock
                                                                    </Label>
                                                                    <Input
                                                                        id="stock"
                                                                        name="stock"
                                                                        type="text"
                                                                        className="form-control mb-2"
                                                                        onChange={(e) =>
                                                                            setCouponStock(
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                        value={couponStock}
                                                                        invalid={
                                         error && error.response.data.stock
                                                                        }
                                                                    />
                                                                    <FormFeedback invalid>
                                                                        {error && error.response.data.stock}
                                                                    </FormFeedback>
                                                                </Col>
                                                                <Col>
                                                                    <Label
                                                                        className="visually-hidden"
                                                                        for="minimum-cart-value"
                                                                    >
                                                                        Minimum Cart Value
                                                                    </Label>
                                                                    <Input
                                                                        id="minimum-cart-value"
                                                                        name="minimum-cart-value"
                                                                        type="text"
                                                                        className="form-control mb-2"
                                                                        onChange={(e) =>
                                                                            setCouponMinimumCartValue(
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                        value={couponMinimumCartValue}
                                                                        invalid={
                                         error && error.response.data.minimum_cart_value
                                                                        }
                                                                    />
                                                                    <FormFeedback invalid>
                                                                        {error && error.response.data.minimum_cart_value}
                                                                    </FormFeedback>
                                                                </Col>
                                                                <Col>
                                                                    <Label
                                                                        className="visually-hidden"
                                                                        for="coupon-max-value"
                                                                    >
                                                                        Max Cart Value
                                                                    </Label>
                                                                    <Input
                                                                        id="coupon-name"
                                                                        name="coupon-max-value"
                                                                        type="number"
                                                                        className="form-control mb-2"
                                                                        onChange={(e) =>
                                                                            setCouponMaxValue(
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                        value={couponMaxValue}
                                                                        invalid={
                                                                            error && error.response.data.max_coupon_value
                                                                        }
                                                                    />
                                                                    <FormFeedback invalid>
                                                                        {error && error.response.data.max_coupon_value}
                                                                    </FormFeedback>
                                                                </Col>
                                                                <Col>
                                                                    <Label
                                                                        className="visually-hidden"
                                                                        for="date-updated"
                                                                    >
                                                                        Date Updated
                                                                    </Label>
                                                                    <Input
                                                                        id="date-updated"
                                                                        name="date-updated"
                                                                        type="date"
                                                                        className="form-control mb-2"
                                                                        onChange={(e) =>
                                                                            setCouponUpdatedDate(
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                        value={couponUpdatedDate}
                                                                        invalid={
                                         error && error.response.data.updated_date
                                                                        }
                                                                    />
                                                                    <FormFeedback invalid>
                                                                        {error && error.response.data.updated_date}
                                                                    </FormFeedback>
                                                                </Col>
                                                            </Row>
                                                        </AccordionBody>
                                                    </AccordionItem>
                                                </Accordion>
                                            </>
                                        )}
                                        <Row className="form-row align-items-center">
                                            {isAdvancedSearchDisabled && (
                                                <Col>
                                                    <Button type="submit"
                                                            className="btn bx-btn-primary waves-effect waves-light mr-2"
                                                            disabled={!couponName && !couponValue && !couponType &&
                                             !couponStatus && !couponCreatedDate}
                                                    >
                                                        Search
                                                    </Button>

                                                    <Button type="button"
                                                            onClick={clearSearchCoupon}
                                                            className="btn bx-btn-primary waves-effect waves-light"
                                                            disabled={!couponName && !couponValue && !couponType &&
                                             !couponStatus && !couponCreatedDate}
                                                    >
                                                        Clear
                                                    </Button>
                                                </Col>
                                            )}
                                            {!isAdvancedSearchDisabled && (
                                                <Col>
                                                    <Button type="submit"
                                                            className="btn bx-btn-primary waves-effect waves-light mr-2"
                                                            disabled={!couponName && !couponValue && !couponType &&
                                             !couponStatus && !couponCreatedDate && !couponCode && !couponStock && !couponMinimumCartValue &&
                                             !couponMaxValue && !couponUpdatedDate}

                                                    >
                                                        Search
                                                    </Button>

                                                    <Button type="button"
                                                            onClick={clearSearchCoupon}
                                                            className="btn bx-btn-primary waves-effect waves-light"
                                                            disabled={!couponName && !couponValue && !couponType &&
                                             !couponStatus && !couponCreatedDate && !couponCode && !couponStock && !couponMinimumCartValue &&
                                                                !couponMaxValue && !couponUpdatedDate}
                                                    >
                                                        Clear
                                                    </Button>
                                                </Col>
                                            )}
                                        </Row>
                                    </Form>
                                </div>
                            </div>
                        </div>
                </AccordionBody>
            </AccordionItem>
            </UncontrolledAccordion>

                        {status === 'loading' && (
                            <Loader size={'default'}/>
                        )}

                        {status === 'success' | error?.response?.status === 401 && (
                            <div className="row">
                                <div className="col-12">

                                    <div className="card-box">
                                        <AddCouponButton/>
                                        <div className="table-responsive">
                                            <table className="table table-centered mb-0">
                                                <thead className="font-13 bg-light text-muted">
                                                <tr>
                                                    <th className="font-weight-medium">Coupon Code</th>
                                                    <th className="font-weight-medium">Products Supported</th>
                                                    <th className="font-weight-medium">Customers Supported</th>
                                                    <th className="font-weight-medium">Value</th>
                                                    <th className="font-weight-medium">Percentage</th>
                                                    <th className="font-weight-medium text-center">Type</th>
                                                    <th className="font-weight-medium">Status</th>
                                                    {/*<th className="font-weight-medium">Expiration</th>*/}
                                                    <th className="font-weight-medium text-center">Created</th>
                                                    <th className="font-weight-medium text-center">Action</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {data?.count > 0? data?.results?.map(coupon => (
                                                    <Coupon key={coupon.id} coupon={coupon}/>
                                                )): <RecordsNotFound/>}
                                                </tbody>
                                            </table>
                                        </div>
                                        {status === 'success' && (
                                            <Paginator data={data} page={page} setPage={setPage} last={data?.last_page} loading={isFetching}/>
                                        )}
                                    </div>
                                </div>
                            </div>
            )}
        </>
    );
}

export default CouponPage;